import { FC } from 'react'
import { SelectAccountType } from './SelectAccountType'
import { CreateCompany } from './Company/CreateCompany'
import { AddUbo } from './Company/AddUbo'
import { AddDirector } from './Company/AddDirector'
import { AddUserOnBoarding } from './Company/AddUserOnBoarding'
import { ResetPassword } from './ResetPassword'
import { CreateUser } from './Individual/CreateUser'
import { TermsAndConditions } from './TermsAndConditions'
import { SumSubstance } from './SumSubstance'
import { SuccesfullyCompleted } from './SuccesfullyCompleted'

export type ComponentProps = {
  title: string
  type?: string
}

export type RootPage = {
  component: FC<ComponentProps>
  title: string
}

export const FormTabs: RootPage[] = [
  {
    component: SelectAccountType, // 0
    title: 'Please select account type!',
  },
  {
    component: CreateCompany, // 1
    title: 'Create Company',
  },
  {
    component: AddUbo, // 2
    title: 'Add UBO',
  },
  {
    component: AddDirector, // 3
    title: 'Add Director',
  },
  {
    component: AddUserOnBoarding, // 4
    title: 'Add User',
  },
  {
    component: ResetPassword, // 5
    title: 'Reset Password',
  },
  {
    component: CreateUser, // 6
    title: 'Create account',
  },
  {
    component: TermsAndConditions, // 7
    title: 'Terms and Conditions',
  },
  {
    component: SumSubstance, // 8
    title: 'Sum & Substance',
  },
  {
    component: SuccesfullyCompleted, // 9
    // title: 'You have successfully completed verification!',
    title: 'Verification may take up to 48 hours. You will be additionally notified by email!',
  },
]
